import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { coverageEventDeepLink, isCoverageEventId } from '../CycleCounts/events/coverageEventLinks'

// The way out of a frozen-proposal refusal: the declaration is settled by the event, not here.
// The id comes from an error payload: anything that is not an event id links nothing.
export const FrozenProposalEventLink = ({ warehouseId, eventId }) => {
  const { i18n } = useTranslation()
  if (!isCoverageEventId(eventId)) return null
  return (
    <Link className="ml-1 text-indigo-700 underline" to={coverageEventDeepLink(warehouseId, eventId)}>
      {i18n.t('found_stock.frozen_proposal.view_event')}
    </Link>
  )
}
